import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Youtube, Instagram } from 'lucide-react';
import { socialLinks, externalLinks } from '../mockData';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-grid">
          {/* About Section */}
          <div className="footer-section">
            <h3 className="footer-heading">Hair Extensions Training Academy</h3>
            <p className="footer-text">
              Led by award-winning salon owner Diane Shawe. Globally accredited training provider since 2006.
            </p>
            <p className="footer-text">
              Over 4100 students trained worldwide.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-subheading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/courses" className="footer-link">Courses</Link></li>
              <li><Link to="/testimonials" className="footer-link">Testimonials</Link></li>
              <li><Link to="/blog" className="footer-link">Blog</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </div>

          {/* External Links */}
          <div className="footer-section">
            <h4 className="footer-subheading">Our Network</h4>
            <ul className="footer-links">
              <li>
                <a href={externalLinks.franchise} target="_blank" rel="noopener noreferrer" className="footer-link">
                  Franchise Opportunities
                </a>
              </li>
              <li>
                <a href={externalLinks.salon} target="_blank" rel="noopener noreferrer" className="footer-link">
                  Book Salon Appointment
                </a>
              </li>
              <li>
                <a href={externalLinks.store} target="_blank" rel="noopener noreferrer" className="footer-link">
                  Online Store
                </a>
              </li>
              <li>
                <a href={externalLinks.blog} target="_blank" rel="noopener noreferrer" className="footer-link">
                  Blog & Resources
                </a>
              </li>
              <li>
                <Link to="/admin" className="footer-link">
                  Admin Portal
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div className="footer-section">
            <h4 className="footer-subheading">Connect With Us</h4>
            <p className="footer-text">National Training Centre</p>
            <p className="footer-text">Phone: +44 20 3051 4338</p>
            <p className="footer-text">Email: info@hairextensionstraining.academy</p>
            <div className="social-links">
              <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="YouTube">
                <Youtube size={20} />
              </a>
              <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="X (Twitter)">
                <Twitter size={20} />
              </a>
              <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Hair Extensions Training Academy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;